import { render, staticRenderFns } from "./GuestRoom.vue?vue&type=template&id=ededc4ce&scoped=true"
import script from "./GuestRoom.vue?vue&type=script&lang=js"
export * from "./GuestRoom.vue?vue&type=script&lang=js"
import style0 from "./GuestRoom.vue?vue&type=style&index=0&id=ededc4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ededc4ce",
  null
  
)

export default component.exports